import { Link } from "react-router-dom";
import ArrowRightTailed from "../../assets/icons/arrows/right-tailed";
import { getMainCategoryColor } from "../../utils/categories";

interface CategoryCardProps {
    id: number | string;
    name: string;
    description?: string;
    icon?: string;
    size?: "small" | "medium" | "large";
    link?: string;
  }

  
export const CategoryCard = ({
    id,
    name,
    description,
    icon,
    size = "large",
    link,
  }: CategoryCardProps) => {
    const color = getMainCategoryColor(typeof id === "number" ? id : 0, true);
  
    return (
      <Link
        className={`categories-card background-${color} ${size}`}
        to={link ?? `/categorie/${id}`}
        target={typeof id === "string" ? "_blank" : undefined}
      >
        {icon && <img className={`categories-card__icon ${size}`} src={icon} alt="icon" />}
        <div className={`categories-card__content ${size}`}>
          <div className="categories-card__content--title">
            <h4 className={`categories-card__title ${size}`}>{name}</h4>
          </div>
  
          {description && (
            <p className="categories-card__description">{description}</p>
          )}
        </div>
        <div className="categories-card__arrow-icon">
          <ArrowRightTailed color={color === "white" ? "navy" : "white"} />
        </div>
      </Link>
    );
  };